/* eslint-disable */
/*********************************************************
/ Glorious generated code by DoneDone's Code Generator.
/ Written by Ka Wai Cheung.
/ Generated on Tuesday, June 24, 2025 9:10:01 PM UTC
/ Don't modify this by hand silly!
*********************************************************/

import { RequestHandler } from '../request-handler'
import {
  ITasksInputUpdateForKanban,
  ITasksInputCreate,
  ITasksInputCreateFromZapier,
  ITasksInputCommentOnly,
  ITasksInputCommentWithUpdate,
  ITasksInputManageCustomFilter,
  ITasksInputUpdateDescription,
  ITasksInputUpdateJobAppointee,
  ITasksInputEditComment,
  ITasksInputUpdateCustomFilter,
  ITasksInputBulkEditAssignee,
  ITasksInputBulkEditStatus,
  ITasksInputBulkEditPriorityLevel,
  ITasksInputBulkEditDueDate,
  ITasksInputBulkEditTags,
  ITasksInputBulkEditComment,
  ITasksInputBulkEditInternalProject,
  ITasksInputBulkEditJobAppointee,
  ITasksInputChecklistItemUpdate,
} from '../types/request.types'
import {
  ITasksOutputSearchForKanban,
  ITasksOutputUpdateForKanban,
  IBulkEditOptions,
  ITasksOutputSearch,
  IPersonBase,
  IPersonWithEmail,
  ITasksOutputAllFilterOptions,
  ITasksOutputRecentlyCreatedForZapier,
  IItemsOutputRecentEventForZapier,
  IItemsOutputItemEventDescription,
  ITasksOutputFilterOptions,
  IItemReference,
  ILinkedItemForListing,
  ITasksOutputDetail,
  ILastUpdatedEpochTime,
  ITasksOutputHistory,
  IItemResponder,
  IPostSuccess,
  ITasksOutputCreateWithFreshnessInfo,
  IGenericJSONMessage,
  IChecklist,
  IChecklistItem,
} from '../types/response.types'

export default new class TasksAPI extends RequestHandler {
  /****** GET methods *****/
  public async get_SearchForKanban(
    internal_project_id: any,
    creator_ids: string,
    priority_ids: string,
    status_ids: string,
    status_type: string,
    assignee_ids: string,
    assigned_not_to_you: boolean,
    job_appointee_groupings_string: string,
    including_tag_ids: string,
    not_including_tag_ids: string,
    due_type: number,
    start_due_date: string,
    end_due_date: string,
    search_term: string,
    only_watching: boolean,
    created_within_days: number,
    last_updated_within_days: number,
  ): Promise<ITasksOutputSearchForKanban> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/search/for-kanban`,
      params: {
        creator_ids,
        priority_ids,
        status_ids,
        status_type,
        assignee_ids,
        assigned_not_to_you,
        job_appointee_groupings_string,
        including_tag_ids,
        not_including_tag_ids,
        due_type,
        start_due_date,
        end_due_date,
        search_term,
        only_watching,
        created_within_days,
        last_updated_within_days,
      },
    })
  }
  public async get_BulkEditOptions(
    internal_project_ids: string,
  ): Promise<IBulkEditOptions> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/tasks/bulk-edit/options`,
      params: {
        internal_project_ids,
      },
    })
  }
  public async get_Search(
    page: number,
    internal_project_ids: string,
    creator_ids: string,
    sort: string,
    priority_ids: string,
    status_ids: string,
    status_type: string,
    assignee_ids: string,
    assigned_not_to_you: boolean,
    job_appointee_groupings_string: string,
    including_tag_ids: string,
    not_including_tag_ids: string,
    due_type: number,
    start_due_date: string,
    end_due_date: string,
    search_term: string,
    only_watching: boolean,
    created_within_days: number,
    last_updated_within_days: number,
  ): Promise<ITasksOutputSearch> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/tasks/search`,
      params: {
        page,
        internal_project_ids,
        creator_ids,
        sort,
        priority_ids,
        status_ids,
        status_type,
        assignee_ids,
        assigned_not_to_you,
        job_appointee_groupings_string,
        including_tag_ids,
        not_including_tag_ids,
        due_type,
        start_due_date,
        end_due_date,
        search_term,
        only_watching,
        created_within_days,
        last_updated_within_days,
      },
    })
  }
  public async get_AllCreators(
  ): Promise<IPersonBase[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/tasks/creators/all`,
    })
  }
  public async get_CreatorContactInfo(
    creator_id: any,
  ): Promise<IPersonWithEmail> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/tasks/creators/${creator_id}/contact-info`,
    })
  }
  public async get_All_FilterOptions(
  ): Promise<ITasksOutputAllFilterOptions> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/tasks/all/filter-options`,
    })
  }
  public async get_RecentlyCreatedForZapier(
    internal_project_id: any,
  ): Promise<ITasksOutputRecentlyCreatedForZapier> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/recently-created-for-zapier`,
    })
  }
  public async get_RecentEventsForZapier(
    internal_project_id: any,
  ): Promise<IItemsOutputRecentEventForZapier> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/recent-events-for-zapier`,
    })
  }
  public async get_EventDescription(
    internal_project_id: any,
    task_id: any,
    task_event_id: any,
  ): Promise<IItemsOutputItemEventDescription> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/event/${task_event_id}/description`,
    })
  }
  public async get_FilterOptions(
    internal_project_id: any,
  ): Promise<ITasksOutputFilterOptions> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/filter-options`,
    })
  }
  public async get_FilterOptionsWithTaskID(
    internal_project_id: any,
    task_id: any,
  ): Promise<ITasksOutputFilterOptions> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/filter-options`,
    })
  }
  public async get_LinkableTasks(
    internal_project_id: any,
  ): Promise<IItemReference[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/linkable-tasks`,
    })
  }
  public async get_LinkableTasksWithTaskID(
    internal_project_id: any,
    task_id: any,
  ): Promise<IItemReference[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/linkable-tasks`,
    })
  }
  public async get_LinkedTasks(
    internal_project_id: any,
    task_id: any,
  ): Promise<ILinkedItemForListing[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/linked-tasks`,
    })
  }
  public async get_LinkedConversations(
    internal_project_id: any,
    task_id: any,
  ): Promise<ILinkedItemForListing[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/linked-conversations`,
    })
  }
  public async get_Detail(
    internal_project_id: any,
    task_id: any,
  ): Promise<ITasksOutputDetail> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}`,
    })
  }
  public async get_LastUpdatedEpochTime(
    internal_project_id: any,
    task_id: any,
  ): Promise<ILastUpdatedEpochTime> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/last-updated-epoch-time`,
    })
  }
  public async get_History(
    internal_project_id: any,
    task_id: any,
    sort: string,
  ): Promise<ITasksOutputHistory[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/history`,
      params: {
        sort,
      },
    })
  }
  public async get_RespondersSinceLastViewed(
    internal_project_id: any,
    task_id: any,
  ): Promise<IItemResponder[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/responders-since-last-viewed`,
    })
  }
  /****** POST methods *****/
  public async post_Create(
    internal_project_id: any,
    data: ITasksInputCreate,
  ): Promise<IPostSuccess> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks`,
      data,
    })
  }
  public async post_CreateWithFreshnessInfo(
    internal_project_id: any,
    data: ITasksInputCreate,
  ): Promise<ITasksOutputCreateWithFreshnessInfo> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/with-freshness-info`,
      data,
    })
  }
  public async post_CreateFromZapier(
    internal_project_id: any,
    data: ITasksInputCreateFromZapier,
  ): Promise<IPostSuccess> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/from-zapier`,
      data,
    })
  }
  public async post_CommentOnly(
    internal_project_id: any,
    task_id: any,
    data: ITasksInputCommentOnly,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/comment-only`,
      data,
    })
  }
  public async post_CommentWithUpdate(
    internal_project_id: any,
    task_id: any,
    data: ITasksInputCommentWithUpdate,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/comment-with-update`,
      data,
    })
  }
  public async post_LinkExistingTasks(
    internal_project_id: any,
    task_id: any,
    listTaskIDs: number[],
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/link-existing-tasks`,
      data: {
        listTaskIDs
      },
    })
  }
  public async post_LinkExistingConversations(
    internal_project_id: any,
    task_id: any,
    listConversationIDs: number[],
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/link-existing-conversations`,
      data: {
        listConversationIDs
      },
    })
  }
  public async post_CreateCustomFilter(
    data: ITasksInputManageCustomFilter,
  ): Promise<IPostSuccess> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/tasks/custom-filters`,
      data,
    })
  }
  public async post_BulkEdit_Comment(
    data: ITasksInputBulkEditComment,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/tasks/bulk-edit/comment`,
      data,
    })
  }
  public async post_ChecklistCreate(
    internal_project_id: any,
    task_id: any,
    title: string,
  ): Promise<IChecklist> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/checklist`,
      data: {
        title
      },
    })
  }
  public async post_ChecklistItemCreate(
    internal_project_id: any,
    task_id: any,
    checklist_id: any,
    name: string,
  ): Promise<IChecklistItem> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/checklist/${checklist_id}/checklist-item`,
      data: {
        name
      },
    })
  }
  /****** PUT methods *****/
  public async put_UpdateForKanban(
    internal_project_id: any,
    task_id: any,
    data: ITasksInputUpdateForKanban,
  ): Promise<ITasksOutputUpdateForKanban> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/for-kanban`,
      data,
    })
  }
  public async put_Title(
    internal_project_id: any,
    task_id: any,
    title: string,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/title`,
      data: {
        title
      },
    })
  }
  public async put_Description(
    internal_project_id: any,
    task_id: any,
    data: ITasksInputUpdateDescription,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/description`,
      data,
    })
  }
  public async put_UnlinkTask(
    internal_project_id: any,
    task_id: any,
    task_id_to_unlink: any,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/unlink-task/${task_id_to_unlink}`,
    })
  }
  public async put_UnlinkConversation(
    internal_project_id: any,
    task_id: any,
    conversation_id_to_unlink: any,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/unlink-conversation/${conversation_id_to_unlink}`,
    })
  }
  public async put_Status(
    internal_project_id: any,
    task_id: any,
    statusID: number,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/status`,
      data: {
        statusID
      },
    })
  }
  public async put_PriorityLevel(
    internal_project_id: any,
    task_id: any,
    priorityID: number,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/priority`,
      data: {
        priorityID
      },
    })
  }
  public async put_Assignee(
    internal_project_id: any,
    task_id: any,
    assigneeID: number,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/assignee`,
      data: {
        assigneeID
      },
    })
  }
  public async put_JobAppointee(
    internal_project_id: any,
    task_id: any,
    data: ITasksInputUpdateJobAppointee,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/job-appointee`,
      data,
    })
  }
  public async put_DueDate(
    internal_project_id: any,
    task_id: any,
    dueDate: string,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/due-date`,
      data: {
        dueDate
      },
    })
  }
  public async put_Tags(
    internal_project_id: any,
    task_id: any,
    listTags: string[],
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/tags`,
      data: {
        listTags
      },
    })
  }
  public async put_Watchers(
    internal_project_id: any,
    task_id: any,
    listWatcherIDs: number[],
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/watchers`,
      data: {
        listWatcherIDs
      },
    })
  }
  public async put_EditComment(
    internal_project_id: any,
    task_id: any,
    task_event_id: any,
    data: ITasksInputEditComment,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/comments/${task_event_id}`,
      data,
    })
  }
  public async put_UpdateCustomFilter(
    custom_filter_id: any,
    data: ITasksInputUpdateCustomFilter,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/tasks/custom-filters/${custom_filter_id}`,
      data,
    })
  }
  public async put_BulkEdit_Assignee(
    data: ITasksInputBulkEditAssignee,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/tasks/bulk-edit/assignee`,
      data,
    })
  }
  public async put_BulkEdit_Status(
    data: ITasksInputBulkEditStatus,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/tasks/bulk-edit/status`,
      data,
    })
  }
  public async put_BulkEdit_PriorityLevel(
    data: ITasksInputBulkEditPriorityLevel,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/tasks/bulk-edit/priority-level`,
      data,
    })
  }
  public async put_BulkEdit_DueDate(
    data: ITasksInputBulkEditDueDate,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/tasks/bulk-edit/due-date`,
      data,
    })
  }
  public async put_BulkEdit_Tags(
    data: ITasksInputBulkEditTags,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/tasks/bulk-edit/tags`,
      data,
    })
  }
  public async put_BulkEdit_Delete(
    listTaskIDs: number[],
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/tasks/bulk-edit/delete`,
      data: {
        listTaskIDs
      },
    })
  }
  public async put_BulkEdit_InternalProject(
    data: ITasksInputBulkEditInternalProject,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/tasks/bulk-edit/internal-project`,
      data,
    })
  }
  public async put_BulkEdit_Watch(
    listTaskIDs: number[],
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/tasks/bulk-edit/watch`,
      data: {
        listTaskIDs
      },
    })
  }
  public async put_BulkEdit_JobAppointee(
    data: ITasksInputBulkEditJobAppointee,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/tasks/bulk-edit/job-appointee`,
      data,
    })
  }
  public async put_ChecklistUpdate(
    internal_project_id: any,
    task_id: any,
    checklist_id: any,
    title: string,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/checklist/${checklist_id}`,
      data: {
        title
      },
    })
  }
  public async put_ChecklistItemUpdate(
    internal_project_id: any,
    task_id: any,
    checklist_id: any,
    checklist_item_id: any,
    data: ITasksInputChecklistItemUpdate,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/checklist/${checklist_id}/checklist-item/${checklist_item_id}`,
      data,
    })
  }
  /****** DELETE methods *****/
  public async delete_Delete(
    internal_project_id: any,
    task_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.delete({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}`,
    })
  }
  public async delete_ChecklistDelete(
    internal_project_id: any,
    task_id: any,
    checklist_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.delete({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/checklist/${checklist_id}`,
    })
  }
  public async delete_ChecklistItemDelete(
    internal_project_id: any,
    task_id: any,
    checklist_id: any,
    checklist_item_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.delete({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tasks/${task_id}/checklist/${checklist_id}/checklist-item/${checklist_item_id}`,
    })
  }
}()
